import React, { FC } from 'react';
import { SmallBlock } from 'store/landing/types';
import cn from 'classnames';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './SmallBlockGroup.module.scss';

export interface SmallBlockGroupProps {
  blocks: SmallBlock[];
}

const SmallBlockGroup: FC<SmallBlockGroupProps> = ({ blocks }) => {
  const [hoverClass, setHoverClass] = React.useState(-1);
  const { theme } = useLandingPageContext();

  return (
    <div className={(styles.container, styles[`theme-${theme}`])}>
      {blocks.map((block, index) => (
        <div className={styles.item} key={block.entryId}>
          <div
            className={styles.item__inner}
            onMouseEnter={() => setHoverClass(index)}
            onMouseLeave={() => setHoverClass(-1)}
          >
            <a href={block.referenceUrl} title={block.title} className={styles.banner}>
              <div className={styles.banner__image} style={{ backgroundImage: `url(${block.imageUrl})` }} />
              <div className={styles.banner__titles}>
                {block.referenceLabel && (
                  <>
                    <h2
                      style={{
                        color: block.referenceLabelColor,
                      }}
                      className={styles.name}
                      dangerouslySetInnerHTML={{ __html: block.title }}
                    />

                    <span
                      className={cn(styles.url, {
                        [styles.url__hover]: hoverClass === index,
                      })}
                      style={{
                        color: block.referenceLabelColor,
                        borderBottomColor: hoverClass === index ? block.referenceLabelColor : 'transparent',
                      }}
                    >
                      {block.referenceLabel}
                      <span className={cn(styles.arrow, styles['arrow--left'])} />
                    </span>
                  </>
                )}
                {!block.referenceLabel && (
                  <h2
                    className={cn(styles.banner__titles__nameUrl, {
                      [styles.url__hover]: hoverClass === index,
                    })}
                    style={{ color: block.titleColor, borderBottomColor: block.titleColor }}
                    dangerouslySetInnerHTML={{ __html: block.title }}
                  />
                )}
              </div>
            </a>
            {block.discount && block.discount.label && block.discount.voucherExpirationDate && (
              <div
                className={styles.banner__discount}
                style={{
                  color: block.discount.fontColor,
                  backgroundColor: block.discount.bubbleBackgroundColor,
                  borderColor: block.discount.bubbleBorderColor,
                }}
              >
                {block.discount.label}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SmallBlockGroup;
